'use strict';

var $ = require('jquery');
var getAbsoluteUrl = require('../lib/getAbsoluteUrl.js');
var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();

function addSocialShare(element, img, title) {
	if (element !== null && element.getAttribute('data-addedsociallinks') !== null)
		return;

	img = getAbsoluteUrl(img);

	element.setAttribute('data-addedsociallinks', true);

	var url = window.location.href;
	var houzzId = document.querySelector('meta[name=houzzId]').getAttribute('content');

	var html = '<span class="socialShare">';

	if (houzzId) {
		// Houzz - You are suppose to use an iframe but the iframe loads very slow. If we find
		//  these buttons break later on then we should switch to the commented code below and remove the CSS we
		//	added to this site (Search css for '.houzz-button')
		html += '<a href="https://www.houzz.com/imageClipperUpload?link='+encodeURIComponent(url)
		+ '&source=button&hzid='+encodeURIComponent(houzzId)
		+ '&imageUrl=' + encodeURIComponent(img)
		+ '&title=' + encodeURIComponent(title)
		+ '&ref=' + encodeURIComponent(url) + '" class="houzz-button" target="_blank"><i class="houzz-logo"></i><span class="label">Save</span></a>';
		//html += '<iframe scrolling="no" frameborder="0" width="52" height="20" src="https://www.houzz.com/buttonWidget&amp;locale=en-us'
		//			+ '?url=' + encodeURIComponent(url)
		//			+ '&amp;ref=' + encodeURIComponent(url)
		//			+ '&amp;img=' + encodeURIComponent(img)
		//			+ '&amp;title=' + encodeURIComponent(title)
		//			+ '&amp;hzid=' + encodeURIComponent(houzzId)
		//			+ '" style="border: none;"></iframe>';
	}

	// Pinterest
	html += '<a class="pin-it-button"'
				+ 'href="https://pinterest.com/pin/create/button/'
				+ '?url=' + encodeURIComponent(url)
				+ '&amp;media=' + encodeURIComponent(img)
				+ '&amp;description=' + encodeURIComponent(title)
				+ '" target="_blank"><img title="Pin It" src="https://assets.pinterest.com/images/PinExt.png"/></a>';

	html += '</span>';

	var $social = $(html);
	$social.appendTo(element);

	element.querySelector('.pin-it-button').addEventListener('click', function() {
		myAnalytics.trackEvent('Share', 'Share - Pinterest', title);
	});

	// Houzz adds class to activate the social link. This will trigger them fading in.
	setTimeout(function() {
		$social.addClass('socialShare--active');
	}, 100);
}

module.exports = addSocialShare;
